// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"1036a15d","807":"05601fe0"}[chunkId] + ".chunk.js";
};